<template>
	<div>
		<firstsceenimage :imgobj='banner' title="星链智能制造解决方案" subtitle="让做鞋更加简单" button="blue" stylemode="blue">
		</firstsceenimage>
		<adword title="当前行业遇到的问题" slotheight="473">
			<div class="flexcenter" style="padding: 10px 50px 10px 50px;">
				<div @mouseenter="swimg2(0)"
					style="position: relative;width: 273px;height:373px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 200px;width: 220px;">
							<div style=" font-size: 20px;letter-spacing: 5px; font-weight: bold;">
								同质化的产品生产
							</div>
							<div class="line-clamp5" style="margin-top: 20px;opacity: 0.7;">
								小单快反成为主流，连续性生产企业受到多样化买方环境的挑战
							</div>
						</div>

					</div>
					<img :class="[swimgbool2[0]?'imgscale':'']" style="height: 373px;z-index: 1;"
						src="../../static/同质化的产品生产.png">
				</div>

				<div style="width: 20px;height: 1px;"></div>
				<div @mouseenter="swimg2(1)"
					style="position: relative;width: 273px;height:373px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 200px;width: 220px;">
							<div style=" font-size: 20px;letter-spacing: 5px; font-weight: bold;">
								生产成本急剧上升
							</div>
							<div class="line-clamp5" style="margin-top: 20px;opacity: 0.7;">
								劳动力短缺与人力成本的提高，让劳动密集型企业难以为继
							</div>
						</div>

					</div>
					<img :class="[swimgbool2[1]?'imgscale':'']" style="height: 373px;z-index: 1;"
						src="../../static/生产成本急剧上升.png">
				</div>
				<div style="width: 20px;height: 1px;"></div>

				<div @mouseenter="swimg2(2)"
					style="position: relative;width: 273px;height:373px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 200px;width: 220px;">
							<div class="line-clamp1" style=" font-size: 20px;letter-spacing: 5px; font-weight: bold;">
								生产协同能力较弱
							</div>
							<div class="line-clamp5" style="margin-top: 20px;opacity: 0.7;">
								企业生产模式固化，人机协同、供应链协同、网络协同等能力较弱
							</div>
						</div>

					</div>
					<img :class="[swimgbool2[2]?'imgscale':'']" style="height: 373px;z-index: 1;"
						src="../../static/生产协同能力较弱.png">
				</div>

				<div style="width: 20px;height: 1px;"></div>
				<div @mouseenter="swimg2(3)"
					style="position: relative;width: 273px;height:373px; overflow: hidden;margin-bottom: 30px;">
					<div style="position:absolute;text-align: left;color: white;z-index: 2;padding-left: 25px;">
						<div style="margin-top: 200px;width: 220px;">
							<div style=" font-size: 20px;letter-spacing: 5px; font-weight: bold;">
								鞋类设计创新不足
							</div>
							<div class="line-clamp5" style="margin-top: 20px;opacity: 0.7;">
								以“人海战术”为主的企业模式难以支撑科研开发与设计创新的需求
							</div>
						</div>

					</div>
					<img :class="[swimgbool2[3]?'imgscale':'']" style="height: 373px;z-index: 1;"
						src="../../static/鞋类设计创新不足.png">
				</div>

			</div>

		</adword>

		<Adbigwordbutton :pagetop="scrolltop" title="AI工厂" title2="让生成全程智能" subtitle="artificial intelligence"
			:imgurl="img2" stylemode="white" hidemb=true>
		</Adbigwordbutton>

		<adword title="数字化协同，为制鞋工厂装上“智慧大脑”"
			subtitle="星链数据将人工智能技术引入鞋履生产全链路管理，打通ERP、CRM、WMS、MES等软硬件系统数据壁垒，辅助工厂智能决策，提升生产效率20%，极大改善工厂订单响应速度。"
			slotheight="320">
			<div class="flexcenter" style=" margin-left: auto;margin-right: auto; margin-top: 30px;">
				<div>
					<img style="height: 85px; width: 85px;" src="../../static/AI数智化协同管理ico.png" />
					<div
						style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
						AI数智化协同管理
					</div>
					<div style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
						部署制鞋工序SaaS系统;全面提高生产;<br>效益节约时间成本;数据可视化
					</div>
				</div>
				
				<div>
					<img style="height: 85px; width: 85px;" src="../../static/灵活应用，智能管理ico.png" />
					<div
						style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
						灵活应用，智能管理
					</div>
					<div style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
						生产、人员、财务等全链路管理;灵活<br>规划，智能管理;功能结构清晰，工厂管理智能化
					</div>
				</div>
				
				<div>
					<img style="height: 85px; width: 85px;" src="../../static/供应链共享平台ico.png" />
					<div
						style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
						供应链共享平台
					</div>
					<div style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
						依托星链S2B2C供应链平台,链接服装<br>产业上下游与合作云工厂共享资源
					</div>
				</div>

			</div>

		</adword>

		<adword title="星链智能制造，为工厂带来了什么" slotheight="320">
			<div class="flexcenter" style=" margin-left: auto;margin-right: auto; margin-top: 30px;">

				<div>
					<img style="height: 85px; width: 85px;" src="../../static/为工厂降本ico.png" />
					<div
						style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
						为工厂降本
					</div>
					<div style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
						助力鞋行业摆脱“以产定销、同质化、高库存、重资产”的<br>传统模式
						节约人力、时间、管理成本
					</div>
				</div>
			 
				<div>
					<img style="height: 85px; width: 85px;" src="../../static/为工厂增效ico.png" />
					<div
						style="font-weight: bold;font-size: 16px;margin-top: 10px;margin-bottom: 10px;color: #333333;letter-spacing: 3px;">
						为工厂增效
					</div>
					<div style="color: #999999; font-size: 12px;margin-top: 9px;line-height: 18px;letter-spacing: 2px;">
						帮助鞋行业向大规模个性化智能定制、小批量、<br>多批次、快生产、云工厂的C2M 数字化转型，提升效能
					</div>
				</div>

			</div>

		</adword>

		<!--合作伙伴  -->
		<adword title="星链智能制造已为200+企业数字化转型" slotheight="280" style="background-color: #1D1F29;color: white;">
			<div class="container">
				<div class="row">
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../../static/logo/kizik.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../../static/logo/奥康.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../../static/logo/华为.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../../static/logo/乐步.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../../static/logo/欧文斯.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../../static/logo/知衣.png" />
					</div>

				</div>
				<div style="height: 20px;"></div>
				<div class="row">
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../../static/logo/三体.png" />
					</div>
					<div class="col-md-2" style="height: 100px; ">
						<img style="height: 100px;background-color: wheat;" src="../../static/logo/易麦斯.png" />
					</div>



				</div>
			</div>

		</Adword>
		<!--合作伙伴end  -->

	</div>
</template>
<script>
	import firstsceenimage from '../../components/firstsceenimage.vue'
	import Adbigwordbutton from '../../components/adBigWordButton.vue'
	import adword from '../../components/adword.vue'
	import banner from '../../static/星链智能制造解决方案banner.png'
	import img2 from '../../static/AI工厂图.png'
	// import video from '../../assets/video/2.mp4'

	export default {
		name: 'Aimake',
		components: {
			firstsceenimage,
			adword,
			Adbigwordbutton,
			// advideo,
		},
		data() {
			return {
				banner: banner,
				img2: img2,
				swimgbool2: [false, false, false, false],
				scrolltop: 0,
			}
		},
		mounted() {

			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件


		},
		methods: {
			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop

			},


			swimg2: function(index) {
				for (var i = 0; i < 6; i++) {
					if (index == i) {
						if (!this.swimgbool2[index]) {
							this.$set(this.swimgbool2, index, true)
						}
					} else {
						this.$set(this.swimgbool2, i, false)
					}
				}

			}
		},

	}
</script>

<style>
</style>
